export const PersonalData = {
    Name: 'Test Name PErsonal info'
};